import { Box, Typography, makeStyles } from "@material-ui/core";
import locale from "@bonliva-crm/locale";
import { Color } from "@bonliva-crm/ui";

export const ColorDescription = (props: { alignLeft?: boolean }) => {
  const classes = useStyles({
    alignLeft: props.alignLeft
  });

  return (
    <Box className={classes.descriptionWrapper}>
      <Box className={classes.flexCenter}>
        <Box
          className={classes.colorBoxCommon}
          style={{
            backgroundColor: Color.PrimaryMain
          }}
        />
        <Typography variant="body2">{locale.Available}</Typography>
      </Box>
      <Box className={classes.flexCenter}>
        <Box
          className={classes.colorBoxCommon}
          style={{
            backgroundColor: Color.Information
          }}
        />
        <Typography variant="body2">{locale.Presented}</Typography>
      </Box>
      <Box className={classes.flexCenter}>
        <Box
          className={classes.colorBoxCommon}
          style={{
            backgroundColor: Color.White,
            backgroundImage: `repeating-linear-gradient(
                    -45deg,
                    ${Color.CheckGreen},
                    rgba(76, 217, 100, 0.35) 2px,
                    rgba(76, 217, 100, 0.35) 2px,
                    ${Color.CheckGreen} 4px
                  )`
          }}
        />
        <Typography variant="body2">{locale.consultantBookingStatus.Booked}</Typography>
      </Box>
    </Box>
  );
};

type StyleProps = {
  alignLeft?: boolean;
};

const useStyles = makeStyles(() => ({
  colorBoxCommon: {
    width: "1rem",
    height: "1rem",
    marginRight: "0.25rem",
    borderRadius: "2px"
  },
  flexCenter: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  descriptionWrapper: (props: StyleProps) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: props.alignLeft ? "flex-start" : "center",
    gap: "1rem",
    padding: "1rem 0",
    margin: "1rem 0",
    width: props.alignLeft ? "100%" : "90%",
    flexWrap: "wrap",
    boxSizing: "border-box",
    borderTop: `1px solid ${Color.LightGray}`
  })
}));
